import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Card KPI per visualizzare il costo totale delle conversazioni.
 * Mostra il valore in euro, il numero di conversazioni e il costo unitario.
 * @param {Object} props - Proprietà del componente
 * @param {Object} props.totalPriceGeneral - Oggetto con total e counter
 * @param {number} props.costPerConversation - Costo per singola conversazione
 * @returns {JSX.Element} Card KPI costo totale
 */
export const InfoTotalPrice = ({ totalPriceGeneral, costPerConversation }) => {
  return (
    <div className="ncard nkpi-card nkpi-card--red">
      <div className="ncard__head">
        <div
          className="ncard__ico"
          style={{ background: 'var(--danger-tint)', color: 'var(--danger)' }}
        >
          <i className="pi pi-euro" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.costoTotale}</h3>
        </div>
      </div>
      <div className="ncard__body">
        <div className="nkpi__value" style={{ color: 'var(--danger)', fontSize: 36 }}>
          {(totalPriceGeneral?.total || 0).toFixed(2)}€
        </div>
        <div style={{ fontSize: 12.5, color: 'var(--ink-500)', marginTop: 6 }}>
          {t.nConversazioni}{' '}
          <strong style={{ color: 'var(--ink-900)', fontWeight: 600 }}>
            {totalPriceGeneral?.counter || 0}
          </strong>
        </div>
        <div style={{ fontSize: 11.5, color: 'var(--ink-400)', marginTop: 2 }}>
          {t.costoAConversazione} €{costPerConversation?.toFixed(2) || 0}
        </div>
      </div>
    </div>
  )
}
